import { TableTennisIcon } from './TableTennisIcon';

/**
 * author: Google
 * id 4E13AA68-FF88-415B-A813-A9D5023F71E3
 * name table-tennis
 * version: 3.6.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/table-tennis.svg
 * tags
 * - Sport 
 */
export const PingPongIcon = TableTennisIcon;
export default PingPongIcon